import ModelGrid from '@/views/Fdc/Detection/Components/ModelGrid'
import ModelConditionGrid from '@/views/Fdc/Detection/Components/ModelConditionGrid'
import LotsModal from '@/views/Fdc/Detection/Components/LotsModal'
import FeatureSelection from '@/views/Fdc/Detection/Multivariate/Tabs/FeatureSelection'
import PCA from '@/views/Fdc/Detection/Multivariate/Tabs/PCA'
import HotelingT2 from '@/views/Fdc/Detection/Multivariate/Tabs/HotelingT2'
import API from '@/views/Fdc/Apis'
import _ from 'lodash'
// import { mapGetters } from 'vuex'

/**
 * Detection > Multivariate Detection
 * Multivariate Detection Model 관리
 */
export default {
  name: 'MultivariateDetection',
  components: {
    'model-grid': ModelGrid, // Detection Model Grid component
    'model-condition-grid': ModelConditionGrid, // Detection Model Condition Grid component
    'lots-modal': LotsModal, // Select LOT Modal component
    'feature-selection': FeatureSelection, // Feature Selection Tab component
    'pca': PCA, // PCA Tab component
    'hoteling-t2': HotelingT2 // Hoteling T2 component
  },
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  methods: {
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Detection Model 목록 조회
     */
    searchModel () {
      this.$refs.modelGrid.searchModel()

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )
      this.initDataValue()
      this.initChart()
    },
    /**
     * Multivariate Detection Model 저장
     */
    async saveData () {
      if (this._saveValidation()) {
        return
      }

      const payload = {
        dataList: this.summaryData,
        modelType: 'MVA'
      }

      await API.Analysis.runPcaBuild(payload, this.callback)
    },
    /**
     * Save Validation
     * @returns {Boolean} validation 성공 여부
     */
    _saveValidation () {
      if (!(this.summaryData.selectedVariables != null && Object.keys(this.summaryData.selectedVariables).length > 0)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Features']))
        return true
      }
      if (this.summaryData.trainingModel == null) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['PCA']))
        return true
      }
      if (this.summaryData.hotelingT2 == null) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['HotelingT2']))
        return true
      }
      return false
    },
    /**
     * Multivariate Detection Model 저장 callback
     * @param {*} response Multivariate Detection Model 저장 결과
     */
    callback (response) {
      if (response.status === 200 && response.data) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
      }
    },
    /**
     * Detection Model row selection event
     * @param {*} row Detection Model row data
     */
    setModelProps (row) {
      // this.searchParamVal()
      console.log('setModelProps', { row })
      this.selectedModelData = row
      this.summaryData = {}
      this.saveBtn.disabled = true
      this.selectedModelCondData = {}
      this.selectedTab(0)
      this.isFeatureSelectionDataExists = false
      this.isPcaDataExists = false
      this.isHotelingT2DataExists = false
      setTimeout(() => this.runFeatureSelection(), 50)
      if (row !== null) {
        this.summaryData.fab = this.selectedTreeNode.detail.fab
        this.summaryData.eqpId = this.selectedTreeNode.detail.eqpId
        this.summaryData.moduleId = this.selectedTreeNode.detail.moduleId
        this.summaryData.modelName = row.modelName
        this.summaryData.modelAlias = row.modelAlias
      }
    },
    initDataValue () {
      this.selectedModelData = {}
      this.summaryData = {}
      this.saveBtn.disabled = true
      this.selectedModelCondData = {}
      this.isFeatureSelectionDataExists = false
      this.isPcaDataExists = false
      this.isHotelingT2DataExists = false
    },
    initChart () {
      this.$refs.featureSelection.briqueChart.purge('mvaDetectionFeatureChart')
      this.$refs.pca.briqueChart.purge('mvaDetectionScreePlot')
      this.$refs.pca.briqueChart.purge('mvaDetectionLoadingChart')
      this.$refs.pca.briqueChart.purge('mvaDetectionScoreChart')
      this.$refs.hotelingT2.briqueChart.purge('mvaDetectionHotelingT2')
    },
    runFeatureSelection () {
      this.$refs.featureSelection.clickRun()
      this.isFeatureSelectionDataExists = true
    },
    runPCA () {
      this.$refs.pca.clickRun()
      this.isPcaDataExists = true
    },
    runHotelingT2 () {
      this.$refs.hotelingT2.clickRun()
      this.isHotelingT2DataExists = true
    },
    /**
     * Detection Model Condition row selection event
     * @param {*} row
     */
    setModelConditionProps (row) {
      // this.searchParamVal()
      this.selectedModelCondData = row
      this.loadChartData()
    },
    /**
     * Detection Model 조회 (선택된 row)
     */
    async loadChartData () {
      const item = this.selectedModelData
      if (item === null) { return }

      const payload = {
        fab: item.fab,
        eqpId: item.eqpId,
        moduleId: item.moduleId,
        modelName: item.modelName,
        recipeId: item.recipeId,
        modelType: 'mva'
      }
      await API.Model.getMvaModel(payload, this.loadCallback)
    },
    /**
     * Detection Model 조회 callback
     * @param {Object} item Detection Model 조회 결과
     */
    loadCallback (item) {
      // chartdata bind 지연으로
      setTimeout(() => {
        this.summaryData = item
        console.log(this.summaryData)
      }, 30)
    },
    /**
     * Select Lot Modal 닫기
     * @param {Boolean} value Modal 표시 여부
     */
    resetModalData (value) {
      this.selectLotsModal.visible = value
    },
    /**
     * Modal Apply Lot callback
     * @param {Array} list 선택된 lot 목록 배열
     */
    applyLots (list) {
      this.selectedLots = list
    },
    /**
     * Select Lot Modal 열기
     */
    showLotsModal () {
      this.selectLotsModal.visible = this.selectedModelData !== null && Object.keys(this.selectedModelData).length > 0 && this.selectedModelCondData !== null && Object.keys(this.selectedModelCondData).length > 0
      if (!this.selectLotsModal.visible) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
      }
    },
    /**
     * Tab 선택 시 event
     * @param {Number} idx tab index
     */
    selectedTab (idx) {
      this.step = idx
    },
    /**
     * Tab 변경 시 event
     */
    onTabsChanged (idx) {
      switch (idx) {
        case 0:
          if (!this.isFeatureSelectionDataExists) setTimeout(() => this.runFeatureSelection(), 50)
          break
        case 1:
          if (!this.isPcaDataExists) setTimeout(() => this.runPCA(), 50)
          break
        case 2:
          if (!this.isHotelingT2DataExists) setTimeout(() => this.runHotelingT2(), 50)
          break
        default:
          break
      }
      this.selectedImportanceData = []
      this.selectedImportanceData = this.$refs.featureSelection.$refs.featureGrid.gridApi.getSelectedRows().map(c => c.variable)
      // 기존 process 주석처리
      // this.$refs.featureSelection.rowData.filter(d => d._status.checked).forEach(row => {
      //   const item = _.clone(row)
      //   delete item['_status']
      //   this.selectedImportanceData.push(item.variable)
      // })
      this.summaryData.selectedVariables = this.selectedImportanceData
      // TODO: 아래 항목 검토
      // this.splitPanesResized()
    },
    /**
     * Save Button 활성화 제어
     * @returns {Boolean} Save Button 활성화 여부
     */
    saveDisabled () {
      return this.saveBtn.disabled
    },
    /**
     * Save Button 활성화 제어
     * Hoteling T2 까지 완료 후 활성화 됩니다.
     */
    modelSaveDisabled (disabled) {
      this.saveBtn.disabled = disabled
    },
    /**
     * Data 초기화
     */
    resetData () {
      let tmpSummary = _.clone(this.summaryData)
      tmpSummary.featureImportance = null
      tmpSummary.trainingModel = null
      tmpSummary.hotelingT2 = null
      this.summaryData = tmpSummary

      // chart 초기화
      this.$refs.featureSelection.briqueChart.purge('mvaDetectionFeatureChart')
      this.$refs.pca.briqueChart.purge('mvaDetectionScreePlot')
      this.$refs.pca.briqueChart.purge('mvaDetectionLoadingChart')
      this.$refs.pca.briqueChart.purge('mvaDetectionScoreChart')
      this.$refs.hotelingT2.briqueChart.purge('mvaDetectionHotelingT2')
    }
  },
  data () {
    return {
      step: 0, // tab index
      isFeatureSelectionDataExists: false,
      isPcaDataExists: false,
      isHotelingT2DataExists: false,
      selectLotsModal: {
        visible: false
      }, // Select Lot Modal 표시 여부
      saveBtn: {
        disabled: true
      }, // Save Button 활성화 여부
      selectedLots: [], // Select Lot Modal에서 선택된 LOT 배열
      selectedTreeNode: [], // 선택된 EQP Tree node
      selectedModelData: {}, // 선택된 Detection Model
      selectedModelCondData: {}, // 선택된 Detection Model Condition
      summaryData: {}, // Summary Data (Feature Selection, PCS, Hoteling T2)
      selectedImportanceData: [] // 선택된 Variable data 배열
    }
  }
}
